function RssEmptyState() {
    try {
        return (
            <div className="text-center py-12 bg-white rounded-lg border border-gray-200" data-name="empty-state">
                <div className="text-6xl mb-4 text-gray-300">
                    <i className="fas fa-rss"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">尚未訂閱任何 RSS 源</h3>
                <p className="text-gray-600 mb-6 max-w-md mx-auto">
                    輸入 RSS 訂閱網址並點擊擷取內容按鈕，開始訂閱您喜愛的網站更新
                </p>
                <div className="bg-orange-50 p-4 rounded-lg border border-orange-200 inline-block text-left">
                    <h4 className="font-medium text-orange-800 mb-2">RSS 網址範例:</h4>
                    <ul className="space-y-1 text-sm text-gray-600">
                        <li><i className="fas fa-rss text-orange-500 mr-2"></i>https://www.ithome.com.tw/rss</li>
                        <li><i className="fas fa-rss text-orange-500 mr-2"></i>https://feeds.feedburner.com/techbang</li>
                        <li><i className="fas fa-rss text-orange-500 mr-2"></i>https://www.inside.com.tw/feed/rss</li>
                    </ul>
                </div>
            </div>
        );
    } catch (error) {
        console.error('RssEmptyState component error:', error);
        reportError(error);
        return null;
    }
}

export default RssEmptyState;